import React from "react";

interface LocationIconProps {
}

const LocationIcon:React.FC<LocationIconProps> = ({}) => {
    return (
        <svg width="24" height="24" version="1.1" viewBox="0 0 4.2333 4.2333" xmlns="http://www.w3.org/2000/svg">
            <path d="m2.1172 0.27905c-0.77249-2e-8 -1.404 0.63438-1.404 1.4087 0 0.40572 0.18964 0.78807 0.4253 1.141 0.23566 0.35295 0.52706 0.6786 0.7829 0.93586l0.19585 0.19585 0.19379-0.19585c0.25584-0.25726 0.5493-0.58291 0.78496-0.93586 0.23566-0.35295 0.42323-0.7353 0.42323-1.141 0-0.77432-0.62949-1.4087-1.402-1.4087zm0 0.54932c0.47433 0 0.85524 0.37992 0.85524 0.85938 0 0.22117-0.12862 0.5306-0.33331 0.83716-0.14898 0.22313-0.33985 0.42337-0.52193 0.62063-0.18231-0.19746-0.37276-0.39722-0.52193-0.62063-0.20469-0.30656-0.3328-0.61599-0.3328-0.83716 0-0.47946 0.38039-0.85938 0.85473-0.85938zm-5.167e-4 0.51211a0.30351 0.30351 0 0 0-0.30334 0.30334 0.30351 0.30351 0 0 0 0.30334 0.30334 0.30351 0.30351 0 0 0 0.30334-0.30334 0.30351 0.30351 0 0 0-0.30334-0.30334z" fill="currentColor" color="currentColor"/>
        </svg>
    )
}

export default LocationIcon;
